/**
  This is to be used to add the tracking properties to an element (usually a <Link>, but seems to work on anything) via the property spread operator

  eg
    {...trackClick("TestEvent", {arbitrary: "value"})}
  will add
    data-metrics-event-name="TestEvent"
    data-metrics-arbitrary="value"
 */
const camelRx = /([a-z])([A-Z])/g;
const dashFn = (m,l,u) => `${l}-${u.toLowerCase()}`;
const camelToDash = camel => camel.replace(camelRx, dashFn).toLowerCase();

export function trackClick(eventName, params, track = true) {
  if (track) {
    const data = {eventName, ...params};

    const add = (props, key) => {
      props[`data-metrics-${camelToDash(key)}`] = data[key];
      return props;
    }

    return Object.keys(data).reduce(add, {});
  }
}

/**
  This is to be used as a helper for AnalyticsApi and its vendor implementations
  It simply passes on all params without altering or mapping them
 */
export function passThroughParams(params/*, map*/) {
  return params;
}

/**
  This is to be used as a helper for AnalyticsApi and its vendor implementations
  It turns a single level key map in to an object of values

  eg
    Map of `{a: "AA", b: "BB"}`
    with data `data-metrics-a="1" data-metrics-b="B"` or `{...trackClick("someEvent", {a: 1, b: 2})}`
    will yeild `{AA: 1, BB: 2}`
 */
export function transformPlainParams(params, map) {
  return Object.keys(params).reduce((obj, key) => {
    if (key in map) {
      obj[map[key]] = params[key];
    }
    return obj;
  }, {});
}

/**
  This is to be used as a helper for AnalyticsApi and its vendor implementations
  It turns a two level key map in to an object of values

  eg
    Map of `{a: {key: "AA", type: "x"}, b: {key: "BB", type: "y"}}`
    with data `data-metrics-a="1" data-metrics-b="B"` or `{...trackClick("someEvent", {a: 1, b: 2})}`
    will yeild `{x: {AA: 1}, y: {BB: 2}}`
 */
export function transformTypedParams(params, map) {
  return Object.keys(params).reduce((obj, key) => {
    if (key in map) {
      obj[map[key].type] = obj[map[key].type] || {};

      obj[map[key].type][map[key].key] = params[key];
    }

    return obj;
  }, {});
}

/**
  Helper that creates a map from a list of keys. Useful in defining a vendor map.

  eg
    simpleMap("foo", "bar")

  returns
    {foo: "foo", bar: "bar"}
 */
export function simpleMap(...paramKeys) {
  return paramKeys.reduce((map, key) => Object.assign(map, {[key]: key}), {});
}



// WEBPACK FOOTER //
// ./utils/AnalyticsUtils.js